import request from '../../axios';

export const postLoanRequest = async () => {
  return await request.post(`/api/v2/payment/loan-request`);
};
